import { Link } from 'react-router';

import { ROUTES } from '@/shared/config';
import { Screen } from '@/shared/ui';

export function NotFoundPage() {
  return (
    <Screen title="Страница не найдена">
      <Link to={ROUTES.home}>На главную</Link>
    </Screen>
  );
}
